import { render } from "./filemgr.vue?vue&type=template&id=2e01bfdc&scoped=true"
import script from "./filemgr.vue?vue&type=script&lang=js"
export * from "./filemgr.vue?vue&type=script&lang=js"

import "./filemgr.vue?vue&type=style&index=0&id=2e01bfdc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e01bfdc"]])

export default __exports__